import DishesTableHeader from './DishesTableHeader';

export default DishesTableHeader;
